import React, { useContext, useEffect, useState } from 'react';
import { noop, isEmpty } from 'lodash';
import { ExpertCardCarousel as ExpertCardCarouselComponent } from '@fiverr-private/listings';
import { EventReportingManagerContext } from '../../../../../../components/EventReportingManager';
import { useEditorAsyncProps } from '../../hooks/useEditorAsyncProps';
import { useCurrencyObject } from '../../hooks/useCurrencyObject';
import type { CurrencyObject } from '../../hooks/useCurrencyObject/utils';
import type { ExpertCardCarouselProps } from './types';

import './index.scss';

const COMPONENT_NAME = 'ExpertCardCarousel';

const ExpertCardCarousel = (props: ExpertCardCarouselProps) => {
    const {
        items: propsItems,
        cardVariant,
        currencyObject,
        carousel_name,
        slidesToShow,
        showPrice,
        showHourlyPrice,
        children,
        contextReferrer,
        source,
    } = props;

    const {
        context: {
            page: { name: pageName },
        },
    } = useContext(EventReportingManagerContext);

    const [items, setItems] = useState(propsItems);
    const editorAsyncProps: Record<string, any> = useEditorAsyncProps(COMPONENT_NAME);
    const currency = useCurrencyObject(currencyObject as CurrencyObject, COMPONENT_NAME);

    useEffect(() => {
        if (!isEmpty(editorAsyncProps?.items)) {
            setItems(editorAsyncProps.items);
        }
    }, [editorAsyncProps]);

    return (
        <ExpertCardCarouselComponent
            items={items as never[]}
            cardVariant={cardVariant}
            currency={currency}
            source={source || pageName}
            componentName={carousel_name || pageName}
            carouselTitle={children as any}
            displayOptions={{ showPrice }}
            slidesToShow={slidesToShow}
            onImpression={noop}
            showHourlyPrice={showHourlyPrice}
            renderFooterContent={null}
            contextReferrer={contextReferrer}
            carouselClassName=""
            slideClassName=""
        />
    );
};

export default ExpertCardCarousel;
